module.exports = __webpack_public_path__ + "img/logo.2dfb26b4.png";